import {ofType} from 'redux-observable';
import {Observable, zip, of} from 'rxjs';
import {flatMap, catchError} from 'rxjs/operators';
import i18next from 'i18next';

import {combineEpics} from 'web-app/util/redux-observable';
import * as OrganizationApi from 'web-app/react/entities/organizations/api';
import * as GlobalEventActions from 'web-app/react/global-event/actions';
import ChildApi from 'web-app/api/child-api';

import * as Actions from './actions';

const changeInstitution = action$ =>
    action$.pipe(
        ofType(Actions.moveSetting.type),
        flatMap(({payload}) =>
            zip(
                of(payload.childId),
                ChildApi.moveChildInstitution(
                    payload.childId,
                    payload.setting,
                    payload.date,
                    payload.includeObservations,
                ),
            ).pipe(
                flatMap(([childId]) => [
                    GlobalEventActions.updateSuccess.action(i18next.t('childProfile.institutionMoveRegistered')),
                    Actions.moveSettingSuccess.action(childId),
                ]),
                catchError(e => of(Actions.moveSettingFailed.action(e))),
            ),
        ),
    );

const fetchInstitutions = action$ =>
    action$.ofType(Actions.fetchInstitutions.type).mergeMap(({payload}) =>
        OrganizationApi.getOrganizationOverview(payload.organizationId)
            .map(institutions => Actions.fetchInstitutionsSuccess.action(institutions))
            .catch(e => Observable.of(Actions.fetchInstitutionsFailed.action(e))),
    );

export default combineEpics(fetchInstitutions, changeInstitution);
